<template>
    <div class="view">
        <vue-headful
                title="Главная | W&S Docs"
        />
        <div v-if="loading" class="loading">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <div id="carouselExampleFade" class="carousel slide carousel-fade" data-ride="carousel">
            <div class="carousel-inner">
                <div class="carousel-item" :class="{ 'active': index === 0 }" v-for="(preview_item, index) in preview" :key="index">
                    <div class="d-block w-100 pl-4 pr-4">
                        <div class="title">
                            <h2>{{ preview_item.preview_title }}</h2>
                        </div>
                        <div class="p" v-html="preview_item.preview_content">
                            {{ preview_item.preview_title }}
                        </div>
                    </div>
                </div>
            </div>
            <a class="carousel-control-prev" href="#carouselExampleFade" role="button" data-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="sr-only">Назад</span>
            </a>
            <a class="carousel-control-next" href="#carouselExampleFade" role="button" data-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="sr-only">Вперёд</span>
            </a>
        </div>

    </div>
</template>

<script>
    import axios from 'axios';
    export default {
        name: "Home",
        data() {
            return {
                preview: [],
                loading: true
            }
        },
        mounted() {
            axios.get('https://api.write-and-share.ml/docs/preview.get')
                .then( response => {
                    this.preview = response.data.response;
                })
                .finally(this.loading = false);
        }
    }
</script>

<style scoped>

</style>
